/**
 * IDs de tracking do site.
 * Podem ser preenchidos aqui ou definidos como variáveis de ambiente VITE_*.
 * Campos vazios são simplesmente ignorados.
 */
const env = import.meta.env as Record<string, string | undefined>;

export const TRACKING = {
  /** Microsoft Clarity — ID do projeto (ex.: "abcd1234") */
  clarityProjectId: env["VITE_CLARITY_PROJECT_ID"] ?? "",
  /** Meta Pixel (Facebook) — Pixel ID numérico (ex.: "123456789012345") */
  metaPixelId: env["VITE_META_PIXEL_ID"] ?? "1865222958219102",
  /** Google Analytics 4 — Measurement ID (ex.: "G-XXXXXXXXXX") */
  ga4MeasurementId: env["VITE_GA4_MEASUREMENT_ID"] ?? "G-8KE9N25RE3",
  /** Google Tag Manager — Container ID (ex.: "GTM-XXXXXXX") */
  gtmContainerId: env["VITE_GTM_CONTAINER_ID"] ?? "GTM-TQ9D4PB2",
  /** Hotjar — Site ID numérico (ex.: "3123456") */
  hotjarSiteId: env["VITE_HOTJAR_SITE_ID"] ?? "",
} as const;
